exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".email-body {\n  margin-top: 10px; }\n\n.email-body pre {\n  white-space: pre-line; }\n\n.btn-right {\n  float: right; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/UI/src/app/communication/email/email.component.scss
// module id = ../../../../../src/app/communication/email/email.component.scss
// module chunks = main